module.exports = __webpack_public_path__ + "static/roboto-regular-11eabca2251325cfc5589c9c6fb57b46.ttf";